import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {VehicleStatusChangeReasonSettingsEntity} from "../../models/vehicle-status-change-reason-settings.model";
import {SettingsService} from "../../services/settings-service.service";

export class VehicleStatusChangeReasonSelectComponent implements IController {

  selectedId: any;
  ngPlaceholder: any;
  isDisabled: any;
  isRequired: boolean;
  onChange: Function;


  public selectedVehicleStatusChangeReason: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private settingsService: SettingsService) {
  }

  $onInit() {
    this._setSelectedVehicleStatusChangeReason();
  };

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()) {
      this._setSelectedVehicleStatusChangeReason();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdRef = this.selectedId;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = 'vehicleStatusChangeReason';
        this.selectedIdsRef = selectedIdRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId) => {
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          selectedId = selectedIdRef;
        }

        if (!selectedId) {
          this.onChange({vehicleStatusChangeReason: undefined, id: undefined});
          panel.destroy();
        } else {
          this.settingsService.getOneVehicleStatusChangeReason(selectedId)
            .then((vehicleStatusChangeReason: VehicleStatusChangeReasonSettingsEntity) => {
              this.onChange({vehicleStatusChangeReason: vehicleStatusChangeReason, id: selectedId});
              panel.destroy();
            });

        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({vehicleStatusChangeReason: undefined, id: undefined});
  }

  private _setSelectedVehicleStatusChangeReason() {
    if (!!this.selectedId) {
      this.settingsService.getOneVehicleStatusChangeReason(this.selectedId)
        .then((vehicleStatusChangeReason: VehicleStatusChangeReasonSettingsEntity) => {
          this.selectedVehicleStatusChangeReason = vehicleStatusChangeReason
          this._setSelectedText()
        });

    } else {
      this.selectedVehicleStatusChangeReason = undefined;
      this._setSelectedText()
    }
  }

  private _setSelectedText() {
    this.selectedText = _.get(this.selectedVehicleStatusChangeReason, 'name', '');
  }
}

angular
  .module('bringoz.admin.site-preferences')
  .component('vehicleStatusChangeReasonSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      selectedId: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./vehicle-status-change-reason-select.html').default,
    controller: VehicleStatusChangeReasonSelectComponent
  });
